module.exports = __webpack_public_path__ + "img/CNAS实验室认可证书.png";